import _ from 'lodash';
const ENCODED_SLASH = '%2F';
const ENCODED_COMMA = '%2C';
const ENCODED_PLUS = '%20';
const ENCODED_EQUALS = '%3D';
const ENCODED_AMPERSAND = '%26';
const ENCODED_QUESTION_MARK = '%3F';
const ENCODED_PERCENT = '%25';

export function parseQueryParams(queryStringSearch: string) {
  const result: Record<string, string> = {};
  const search =
    queryStringSearch &&
    queryStringSearch
      .replace(new RegExp(ENCODED_SLASH, 'g'), '/')
      .replace(new RegExp(ENCODED_COMMA, 'g'), ',')
      .replace(new RegExp(ENCODED_PLUS, 'g'), '+')
      .replace(new RegExp(ENCODED_EQUALS, 'g'), '=')
      .replace(new RegExp(ENCODED_AMPERSAND, 'g'), '&')
      .replace(new RegExp(ENCODED_QUESTION_MARK, 'g'), '?')
      .replace(new RegExp(ENCODED_PERCENT, 'g'), '%');
      
  if (!search) {
    return result;
  }

  const paramsString = search.replace('?', '');
  if (!paramsString) {
    return result;
  }

  paramsString.split('&').forEach((queryParam) => {
    const queryParamSplitted = queryParam.split('=');
    const key = queryParamSplitted[0];
    const value = _.join(_.tail(queryParamSplitted), '=');
    result[key] = value;
  });
  return result;
}